import { render, staticRenderFns } from "./SignatureDetail.vue?vue&type=template&id=65baab42&scoped=true"
import script from "./SignatureDetail.vue?vue&type=script&lang=js"
export * from "./SignatureDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65baab42",
  null
  
)

export default component.exports